function showDrawer() {
    document.body.classList.add('show-drawer');
}

function hideDrawer() {
    document.body.classList.remove('show-drawer');
}

var fabricSampleButton = document.getElementById('fabric_sample');
var fabricCloseButton = document.getElementById('close-fabric-swatch_drawer');
fabricSampleButton?.addEventListener('click', function() {
    $('.modal--wraper').toggleClass('is-visible');
    $('body').toggleClass('bg-scroll-off');
});

$(document).ready(function() {
    var fabricColours = [];
    (fabricId = []), (fabricPrice = []), (fabricAvailability = []), (fabricImage = []);
    fabricOptions = document.getElementById('fabricOptions');
    $('.swatch-fabric-product__tile').each(function() {
        var colorName = $(this).find('.product_tile_color_current').attr('data-product_title').replace(/\s+/g, '-');
        var imgSrc = $(this).find('.product_tile_color_current').attr('src');
        var productID = $(this).find('.product_tile_color_current').attr('data-product_id');
        var price = $(this).find('.product_tile_color_current').attr('data-price');
        var availability = $(this).find('.product_tile_color_current').attr('data-availability');
        fabricId.push(productID);
        fabricAvailability.push(availability);
        fabricPrice.push(price);
        fabricColours.push(colorName);
        fabricImage.push(imgSrc);
    });

    for (var x = 0; x < fabricColours.length; x++) {
        var isActive = fabricAvailability[x] ? 'active' : 'disabled';
        var priceSet = fabricAvailability[x] ? fabricPrice[x] : '<span style="color:#9f332a;"><b>Out of stock</b></span>';
        var colorSwatch =
            '<div class="' +
            fabricColours[x] +
            ' ' +
            isActive +
            '">' +
            '<div class="left price-swatch" >' +
            priceSet +
            '</div>' +
            '<input class="left checkbox swatchOption"' +
            'style="position:relative; z-index:999; width:30px; height:30px; opacity:0;"' +
            'type="checkbox"' +
            'id="' +
            fabricId[x] +
            '"' +
            'value="' +
            fabricColours[x] +
            '"' +
            '/>' +
            '<div class="left swatchReq" style="padding-left: 1em;">' +
            fabricColours[x].replace(/-/g, ' ') +
            '</div>' +
            '<img class="color-swatch" style="position:absolute; top:0; left:0; z-index:99;" src="' +
            fabricImage[x] +
            '">' +
            '<span class="mto-swatch-icon mto-swatch-icon--tick mto-swatch-icon--tick--selected">' +
            '<img src="https://www.daals.co.uk/cdn/shop/t/608/assets/icons8-tick-white-24.png?v=61965968832104827231790259992" loading="lazy" class="lazy" style="width: 53px;"></span>' +
            '</div>';
        fabricOptions.insertAdjacentHTML('afterBegin', colorSwatch);
    }

    setTimeout(function() {
        [].forEach.call(document.querySelectorAll('.checkbox'), function(el, i) {
            el.addEventListener('click', function() {
                if (el.parentNode.querySelector('.color-swatch').classList.contains('active')) {
                    el.parentNode.querySelector('.color-swatch').classList.remove('active');
                    el.parentNode.querySelector('.swatchReq').classList.remove('active');
                } else {
                    el.parentNode.querySelector('.color-swatch').classList.add('active');
                    el.parentNode.querySelector('.swatchReq').classList.add('active');
                }
            });
        });

        [].forEach.call(document.querySelectorAll('.swatchReq'), function(el) {
            el.addEventListener('click', function() {
                el.previousSibling.click();
            });
        });
        $('img.color-swatch').click(function() {
            $(this).parent().find('input').trigger('click');
        });
    }, 200);

    $('#AddToCart-swatch-product').click(function() {
        var upsellItemsArray = new Array();
        var swatchCheckboxAll = document.querySelectorAll('#fabricOptions input.checkbox');
        swatchCheckboxAll &&
            swatchCheckboxAll.forEach((el, i) => {
                let variantId = Number(el.id);
                if (el.checked) {
                    upsellItemsArray.push({
                        id: variantId,
                        quantity: 1,
                    });
                }
            });
        if (upsellItemsArray.length > 0) {
            $.ajax({
                    method: 'POST',
                    url: '/cart/add.js',
                    dataType: 'json',
                    data: JSON.stringify({
                        items: upsellItemsArray,
                    }),
                    contentType: 'application/json',
                })
                .done(function(resp) {
                    hideDrawer();
                    window.roar.updateCartSidebar("panel");
                    setTimeout(function() {
                        $('.modal--wraper').toggleClass('is-visible');
                        $('body').toggleClass('bg-scroll-off');
                    }, 200);
                })
                .fail(function(jqXHR, textStatus, errorThrown) {
                    // Handle error response
                    console.error('Error:', jqXHR.status);
                    alert('Some of the item has no stock or already in cart. Pls refresh the cart');
                });
        } else {
            alert('Please select swatch first');
        }
    });
    $('.modal--bg, .close-fabric-swatch').on('click', function(e) {
        $('.modal--wraper').toggleClass('is-visible');
        $('body').toggleClass('bg-scroll-off');
    });
});